import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import shippingFeesConstant from '../constants/shipping_fees_contsants';
import actionTypes from '../constants/action_types';

class shippingAdFees extends ReduceStore {
  getInitialState() {
    return []
  }

  reduce(state, { source, action }) {
    if (source === actionTypes.SHIPPING_ACTION) {
      switch (action.type) {
        case shippingFeesConstant.RECEIVE_AD_SHIPPING_DATA:
          state = action.payload;
          break;

        case shippingFeesConstant.RECEIVE_AD_SHIPPING_FAIL:
          console.error(`Fetch API ${action.payload.statusText} with status code: ${action.payload.status}`)
          state = [];
          break;
        default:
          state
      }
    }
    return state;
  }

}

const shippingAdFeesStore = new shippingAdFees(Dispatcher);
export default shippingAdFeesStore;